import { stores } from "./stores/index";
const version = process.env.VERSION;
console.log(`=========== mobx-snackabra-store v${version} loading ===========`);
export { stores };
